/**
 * Enum values for the Club Modules
 */
export enum ModulesType {
  CRM_MEMBERSHIP = 'crm_membership',
  CAMPAI_MEMBERSHIP = 'campai_membership',
  CAMPAIGN = 'campaign',
  MERCHANDISING = 'merchandising',
  LOTTERY = 'lottery',
  TIXX_WEBSHOP = 'tixx_webshop',
  CUSTOMER = 'customer',
  EVENTIM_DATA_FEED = 'eventim_data_feed',
  CUSTOMER_SCORE = 'customer_score',
  INVOICE = 'invoice',
  FAN_PORTAL = 'fan_portal',
}
